import { initFilterCardFeatures } from '../components/initFilterCardFeatures';
import { firstRenderFeatures } from '../helper-functions/firstRenderFeatures';

window.addEventListener('DOMContentLoaded', handleOnLoadPage, false);

function handleOnLoadPage() {
    firstRenderFeatures('general');
    initFilterCardFeatures();
}
